import { initializePublicPage } from "@/lib/publicPage";

initializePublicPage();

const headerRoot = document.getElementById("public-header-root");
const headerContext = document.getElementById("public-header-context");
if (headerRoot && headerContext) {
  void import("@/lib/publicHeader").then(({ mountPublicHeader }) => {
    mountPublicHeader(headerRoot, JSON.parse(headerContext.textContent ?? "{}"));
  }).catch(() => { /* The server-rendered navigation remains usable. */ });
}

const languageRoot = document.getElementById("public-language-root");
if (languageRoot) {
  void import("@/lib/publicHeader").then(({ mountPublicLanguageSelector }) => {
    mountPublicLanguageSelector(languageRoot, {
      current: document.documentElement.lang,
      csrfToken: document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content ?? "",
    });
  }).catch(() => { /* The server-rendered language forms remain usable. */ });
}
